import types from "./types";


export const sendBulkNotificationsStart = payload => ({
    type: types.SEND_BULK_NOTIFICATIONS_START,
    payload,
});
export const sendBulkNotificationsStateReset = () => ({
    type: types.SEND_BULK_NOTIFICATIONS_STATE_RESET,
});